import request from '@/utils/request'

// 首页相关的接口
export function addressList() {
    return request.post('/home/getHomeInfo')
}


// export function getInfo() {
//     return request({
//       url: '/home/getHomeInfo',
//       method: 'post',
//     })
//   }
